<div class="container">
  <pdq-heading element="h6">Yotpo App Key</pdq-heading>
  <div class="general">
    <pdq-input
      [value]="yotpoAppKey"
      placeholder="Not configured"
      [readonly]="true"
      type="password"
      [clipboard]="!!yotpoAppKey"></pdq-input>
    @if (yotpoAppKey) {
      <p class="hint body-12-regular">To change your App Key, disconnect and reconnect.</p>
    } @else {
      <p class="hint body-12-regular">Click Connect at the top of the page to enter your Yotpo App Key.</p>
    }
  </div>
</div>
